import { render, staticRenderFns } from "./mediaSpaceCom.vue?vue&type=template&id=3cdc8d42&scoped=true"
import script from "./mediaSpaceCom.vue?vue&type=script&lang=js"
export * from "./mediaSpaceCom.vue?vue&type=script&lang=js"
import style0 from "./mediaSpaceCom.vue?vue&type=style&index=0&id=3cdc8d42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc8d42",
  null
  
)

export default component.exports